"use client";

import { useId } from "react";
import { Input } from "~/components/ui/input";
import { ListChoice } from "./ListFilterControls";
import type { ListDateFilter } from "./listProjection";

export type DateDraft = Readonly<{ mode: ListDateFilter["mode"]; days: string; start: string; end: string }>;

export function ListDateControls({ draft, invalid, onChange }: { draft: DateDraft; invalid: boolean; onChange: (draft: DateDraft) => void }) {
  const errorId = useId();
  const errors = { "aria-invalid": invalid, "aria-describedby": invalid ? errorId : undefined };
  return <div className="space-y-3 dark:[color-scheme:dark]">
    <ListChoice label="Период загрузки" value={draft.mode} choices={[["all", "Все даты"], ["last-days", "Последние N дней"], ["interval", "Интервал дат"]]} onChange={(mode) => onChange({ ...draft, mode })} />
    {draft.mode === "last-days" && <label className="block space-y-1 text-sm">
      <span>Количество дней</span>
      <Input type="number" aria-label="Количество дней" {...errors} value={draft.days} onChange={(event) => onChange({ ...draft, days: event.target.value })} />
    </label>}
    {draft.mode === "interval" && <>
      <label className="block space-y-1 text-sm"><span>Дата начала</span>
        <Input type="date" aria-label="Дата начала" {...errors} value={draft.start} onChange={(event) => onChange({ ...draft, start: event.target.value })} className="min-w-0" />
      </label>
      <label className="block space-y-1 text-sm"><span>Дата окончания</span>
        <Input type="date" aria-label="Дата окончания" {...errors} value={draft.end} onChange={(event) => onChange({ ...draft, end: event.target.value })} className="min-w-0" />
      </label>
    </>}
    {invalid && <p id={errorId} role="alert" className="text-sm text-red-700 dark:text-red-400">Некорректный период дат</p>}
  </div>;
}
